/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import {
  UPDATE_CERTIFICATION_PATHWAYS,
  CERTIFICATION_ASSESSMENT_REQUESTED_SUCCESS,
  CERTIFICATION_STUDENT_REGISTERED_SUCCESS,
  CERTIFICATION_ISSUED_SUCCESS,
  CERTIFICATION_PROMPT_RETRY_SUCCESS,
  CERTIFICATION_UNDO_PROMPT_RETRY_SUCCESS,
  CERTIFICATION_REFRESHED_SUCCESS,
} from './actions';
import {
  SAVE_CERTIFICATE_LINK,
  FETCH_STUDENT_CERTIFICATIONS_SUCCESS,
} from '../actions';
import { COURSE_NAVIGATION_DATA_SET } from '../../CourseNavigationInfo/actions';

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function CertificationPathways(state = Immutable.Map(), action = {}) {
  switch (action.type) {
    case UPDATE_CERTIFICATION_PATHWAYS:
    case FETCH_STUDENT_CERTIFICATIONS_SUCCESS: {
      const certificationPathways = Immutable.fromJS(
        action.certificationPathways
      );
      let updatedState = state;

      for (const certificationPathway of certificationPathways.values()) {
        updatedState = updatedState.set(
          certificationPathway.get('id'),
          certificationPathway
        );
      }
      return updatedState;
    }
    case CERTIFICATION_ASSESSMENT_REQUESTED_SUCCESS:
    case CERTIFICATION_STUDENT_REGISTERED_SUCCESS:
    case CERTIFICATION_ISSUED_SUCCESS:
    case CERTIFICATION_REFRESHED_SUCCESS:
    case CERTIFICATION_PROMPT_RETRY_SUCCESS:
    case CERTIFICATION_UNDO_PROMPT_RETRY_SUCCESS:
    case COURSE_NAVIGATION_DATA_SET:
    case SAVE_CERTIFICATE_LINK: {
      const certificationPathway = Immutable.fromJS(
        action.certificationPathway
      );
      return certificationPathway
        ? state.set(certificationPathway.get('id'), certificationPathway)
        : state;
    }
    default: {
      return state;
    }
  }
}
